import React, {useCallback, useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import {Campaign} from "./campaign";
import Datatable from "../../datatable/datatable";
import {CampaignService} from "./campaign.service";
import {changePageTitle, setAlert} from "../../redux/actions";
import {ColorButtonEnum} from "../../util/color-button-enum";
import {ColorIconEnum} from "../../util/color-icon-enum";
import {Delete as DeleteIcon} from "@mui/icons-material";
import PersonIcon from '@mui/icons-material/Person';

const CampaignList = React.memo(() => {

    let navigate = useNavigate();
    const dispatch = useDispatch();
    const [items, setItems] = useState<Campaign[]>([]);
    const [page, setPage] = useState<number | undefined>(0);
    const [size, setSize] = useState<number | undefined>(parseInt(process.env.REACT_APP_PAGE_SIZE || "0"));
    const [sort, setSort] = useState<string | undefined>('id,asc');
    const [filter, setFilter] = useState<string | undefined>('');

    const findAll = useCallback(async (page?: number, size?: number, sort?: string, filter?: string) => {
        const result = await CampaignService.findAll(page, size, sort, filter);
        setItems(result.content);
        setPage(page);
        setSize(page);
        setSort(sort);
        setFilter(filter);
    }, []);

    useEffect(() => {
        dispatch(changePageTitle("Campanhas"));
        findAll(page, size, sort, filter).then();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const insertItem = () => {
        navigate('/campaign');
    }

    const editItem = (item: Campaign) => {
        navigate('/campaign/' + item.id);
    }

    const deleteItem = (item: Campaign) => {
        if (item.id) {
            CampaignService.delete(item.id).then(() => {
                findAll(page, size, sort, filter).then();
            }).catch((error) => {
                dispatch(setAlert({
                    show: true,
                    message: 'Erro ao excluir registro - ' + error.response.data.message,
                    severity: 'error'
                }));
            })
        }
    }

    const persons = (item: Campaign) => {
        navigate('/campaign/' + item.id + "/persons");
    }

    const headerOperations = [{color: () => ColorButtonEnum.PRIMARY, onClick: insertItem, label: () => 'Inserir'}];

    const rowOperations = [
        {
            color: () => ColorIconEnum.PRIMARY,
            onClick: deleteItem,
            label: () => 'Excluir',
            icon: () => <DeleteIcon/>
        },
        {
            color: () => ColorIconEnum.PRIMARY,
            onClick: persons,
            label: () => 'Pessoas',
            icon: () => <PersonIcon/>
        }
    ];

    return (
        <React.Fragment>
            <Datatable
                dataColumnNames={['ID', 'Descrição']}
                dataColumns={['id', 'description']}
                dataTypes={['number', 'text']}
                findAll={findAll}
                page={page}
                size={size}
                sort={sort}
                filter={filter}
                editData={editItem}
                data={items}
                totalData={items.length}
                headerOperations={headerOperations}
                rowOperations={rowOperations}
            />
        </React.Fragment>
    )

});

export default CampaignList;